module.exports = __webpack_public_path__ + "media/assets/img/company/logo Ubicast-450fba1bdae907ef32260868e0201134.png";